module.exports = __webpack_public_path__ + "static/Prof.DwikoraNovembriUtomoMDPhD-a407ed17bbab60d25bf6fa1622317d97.jpg";